import { IIframeBlockResponse } from '~/types/server.types';
import { FlowRevision } from '~/models/flow-revision.model';
import { CXBaseBlock } from '~/components/ClientExperience/OneFlow/models/cx-base-block.model';
import { computed, observable } from 'mobx';
import type { CXRootStore } from '~/components/ClientExperience/stores/cx-root.store';

export class CXIframeBlock extends CXBaseBlock {
    type: 'iframe_block';
    @observable url: string;
    @observable height: number;
    @observable width: number;

    constructor(
        block: IIframeBlockResponse,
        flowRevision: FlowRevision<CXRootStore>,
        rootStore: CXRootStore
    ) {
        super(block, flowRevision, rootStore);
        this.type = block.type as 'iframe_block';
        this.url = block.url || '';
        this.height = block.height || 500;
        this.width = block.width || 100;
    }

    @computed
    get isDeletable(): boolean {
        return true;
    }

    shouldRender(): boolean {
        return !!this.url;
    }
}
